import { render, staticRenderFns } from "./ShowBook.vue?vue&type=template&id=5c5d3e8f&scoped=true"
import script from "./ShowBook.vue?vue&type=script&lang=js"
export * from "./ShowBook.vue?vue&type=script&lang=js"
import style0 from "./ShowBook.vue?vue&type=style&index=0&id=5c5d3e8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5d3e8f",
  null
  
)

export default component.exports